import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'keepHtml',
    pure: false
})
export class EscapeHtmlPipe implements PipeTransform {

    constructor(
        private sanitizer: DomSanitizer
    ) { }

    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
        // return this.sanitizer.bypassSecurityTrustScript(value);
        // return this.sanitizer.bypassSecurityTrustUrl(value);
        // return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/pipes/keep-html.pipe.ts